import MDB from '../marketingdb';

const isGuid = (s) => MDB.isGuid(s);
const guid = () => MDB.guid();
const emptyGuid = '00000000-0000-0000-0000-000000000000';

export {
    isGuid,
    guid,
    emptyGuid
};